'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var MaterialDialogContent = _interopDefault(require('@material-ui/core/DialogContent'));

var contentMarginStyles = {
    sm: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    margin: 16px 32px 24px 32px;\n  "], ["\n    margin: 16px 32px 24px 32px;\n  "]))),
    md: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    margin: 24px 32px 24px 32px;\n  "], ["\n    margin: 24px 32px 24px 32px;\n  "]))),
};
var StyledContent = styled__default(MaterialDialogContent)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  &.root {\n    justify-content: center;\n    padding: 0px;\n    ", "\n  }\n"], ["\n  &.root {\n    justify-content: center;\n    padding: 0px;\n    ", "\n  }\n"])), function (_a) {
    var contentMargin = _a.contentMargin;
    return contentMarginStyles[contentMargin];
});
var DialogContent = function (_a) {
    var children = _a.children, dataCy = _a.dataCy, _b = _a.contentMargin, contentMargin = _b === void 0 ? 'sm' : _b, restProps = tslib_es6.__rest(_a, ["children", "dataCy", "contentMargin"]);
    return (React__default.createElement(StyledContent, tslib_es6.__assign({ contentMargin: contentMargin, classes: { root: 'root' }, "data-cy": dataCy }, restProps), children));
};
var templateObject_1, templateObject_2, templateObject_3;

exports.DialogContent = DialogContent;
